import { Cell, Grid, HeadingSection, InfoLabel, Text, useStyles } from 'bold-ui'
import { AccordionCompositeItem } from 'components/accordion/AccordionCompositeItem'
import { Accordion } from 'react-accessible-accordion'

import { getPerguntasRespondidas } from '../utils-mamografia'
import { IndicacaoClinicaMamografiaAccordionBody } from './IndicacaoClinicaMamografiaAccordionBody'
import {
  MAMOGRAFIA_DIAGNOSTICA_SECTIONS,
  MAMOGRAFIA_PERGUNTAS_INDICACAO_CLINICA,
  QuestoesRespondidasMap,
} from './model-indicacaoClinica'

export interface MamografiaIndicacaoClinicaVisualizacaoSectionProps {
  questoesRespondidas: QuestoesRespondidasMap
}

export function MamografiaIndicacaoClinicaVisualizacaoSection(
  props: Readonly<MamografiaIndicacaoClinicaVisualizacaoSectionProps>
) {
  const { questoesRespondidas } = props
  const { classes } = useStyles(createStyles)

  const perguntasTopo = getPerguntasRespondidas(MAMOGRAFIA_PERGUNTAS_INDICACAO_CLINICA, questoesRespondidas)

  const secoesVisiveis = MAMOGRAFIA_DIAGNOSTICA_SECTIONS.filter(
    ({ perguntas }) => getPerguntasRespondidas(perguntas, questoesRespondidas).length > 0
  )

  if (perguntasTopo.length === 0 && secoesVisiveis.length === 0) return null

  return (
    <>
      <HeadingSection level={4} vSpace={2} title='INDICAÇÃO CLÍNICA' />
      <Grid style={classes.grid}>
        {perguntasTopo.map(({ name, label, resposta }) => (
          <Cell key={name} size={6}>
            <InfoLabel title={label}>{resposta}</InfoLabel>
          </Cell>
        ))}
      </Grid>
      {secoesVisiveis.length > 0 && (
        <Accordion allowZeroExpanded>
          <AccordionCompositeItem
            header={<Text fontWeight='bold'>Mamografia diagnóstica - Achados no exame clínico</Text>}
            body={
              <IndicacaoClinicaMamografiaAccordionBody
                questoesRespondidas={questoesRespondidas}
                secoes={secoesVisiveis}
              />
            }
          />
        </Accordion>
      )}
    </>
  )
}

const createStyles = () => ({
  grid: {
    width: '100%',
  },
})
